var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "@emotion/react";
import styled from "@emotion/styled";
export var tabHeaderBorderBottom = "1px solid #ffffff59";
export var tabHeaderMarginBottom = function (theme) {
    return theme.dimensions.margin.large;
};
export var tabHeaderPadding = function (theme) {
    return "".concat(theme.dimensions.margin.large, " 0");
};
export var TabHeader = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\tborder-bottom: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tmargin-bottom: ", " !important;\n\t\t\tpadding: ", ";\n\t\t\twidth: 100%;\n\t\t"], ["\n\t\t\tborder-bottom: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tmargin-bottom: ", " !important;\n\t\t\tpadding: ", ";\n\t\t\twidth: 100%;\n\t\t"])), tabHeaderBorderBottom, theme.typography.fontSize.large, tabHeaderMarginBottom(theme), tabHeaderPadding(theme));
});
export var TabSubHeader = styled.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t\tfont-size: ", ";\n\t\t\tmargin: 0 0 ", " 0;\n\t\t"], ["\n\t\t\tfont-size: ", ";\n\t\t\tmargin: 0 0 ", " 0;\n\t\t"])), theme.typography.fontSize.base, theme.dimensions.margin.large);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
